import React, { ReactNode } from 'react';
import styled, { keyframes } from 'styled-components';
import { Link } from 'react-static';
import { getLinkTarget } from '@flow/utils/cleaners';
import em from 'polished/lib/helpers/em';

const slideForward = keyframes`
  0%,
  100% {
    transform: translate(0, 0);
  }

  50% {
    transform: translate(15px, 0);
  }
`;

const slideBackward = keyframes`
  0%,
  100% {
    transform: translate(0, 0);
  }

  50% {
    transform: translate(-15px, 0);
  }
`;

const Button = styled.span`
  white-space: nowrap;
  font-family: Flow-Poster-Bold;
  text-transform: uppercase;
  font-size: 2.8em;
  line-height: ${em(4.8, 2.8)};
  
  a:after {
    content: '→';
  }
  
  a:before {
    content: '←';
  }
  
  a:before, a:after {
    font-family: Flow-Poster-Bold;
    display: inline-block;
  }
  
  a:before {
    display: ${props => !props.showAsBackArrow ? 'none' : 'inline-block'};
    margin-right: ${em(1.6, 4)};
    //transform: rotate(-180deg);
  }
  
  a:after {
    display: ${props => props.showAsBackArrow ? 'none' : 'inline-block'};
    margin-left: ${em(1.6, 4)};
  }
  
  &:${props => props.theme.hoverProperty} {
    a {
      color: ${props => props.highlightColor ? props.highlightColor : props.theme.highlightColor};
      
      &:before {
        animation: ${slideBackward} 0.6s ease-in-out 1;
      }
      
      &:after {
        animation: ${slideForward} 0.6s ease-in-out 1;
      }
    }
  }
  
  @media (max-width: 1000px) {
    font-size: ${28/(1000*0.01)}vw;
  }
  
  @media (max-width: 650px) {
    font-size: 2em;
    white-space: normal;
  }
`;

interface Props {
  label: string | ReactNode;
  href?: string;
  target?: string;
  highlightColor?: string;
  showAsBackArrow?: boolean;
  onClick?(): void;
  children?: JSX.Element;
}

const BasicButton = ({
  label,
  href,
  showAsBackArrow,
  highlightColor,
  target,
  onClick,
  children
}: Props) => {

  function handleClick() {
    if (!onClick) {
      return;
    }
    onClick();
  }

  if (href) {
    return (
      <Button highlightColor={highlightColor} showAsBackArrow={showAsBackArrow}>
        <Link to={href} target={getLinkTarget(target)}>
          {label || ''}
          {children}
        </Link>
      </Button>
    )
  } else {
    return (
      <Button highlightColor={highlightColor} showAsBackArrow={showAsBackArrow}>
        <a onClick={handleClick}>
          {label || ''}
          {children}
        </a>
      </Button>
    )
  }
};

export default BasicButton;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/ui/button/BasicButton.tsx